import { axios } from '@/plugins/axios';
import { Speaker } from '@/models/speaker';

export class SpeakerService {
  endpoint: string;

  constructor() {
    this.endpoint = 'v1/speakers/';
  }

  async fetchSpeakers(event: string) {
    return axios
      .get(`${this.endpoint}?event=${event}`)
      .then(({ data }) => data);
  }

  async fetchSpeaker(id: number) {
    return axios.get(`${this.endpoint}${id}/`).then(({ data }) => {
      console.log(data);
      return data;
    });
  }

  async createSpeaker(payload: object) {
    return axios.post(`${this.endpoint}`, payload).then(({ data }) => data);
  }

  async updateSpeaker(payload: Speaker, id?: number) {
    return axios
      .patch(`${this.endpoint}${id ? id : payload.id}/`, payload)
      .then(({ data }) => data);
  }

  async deleteSpeaker(id: number) {
    return axios.delete(`${this.endpoint}${id}/`);
  }

  async optionsSpeaker() {
    return axios({ method: 'options', url: `${this.endpoint}` }).then(
      ({ data }) => data
    );
  }

  async optionSpeaker(id: number) {
    return axios({ method: 'options', url: `${this.endpoint}${id}/` }).then(
      ({ data }) => data
    );
  }
}
